// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"aa8cec8a","107":"cb5931f4","231":"4722c213","281":"f2b2584d","561":"b4b00f2a"}[chunkId] + ".chunk.js";
};